// service lib
import isDiscountService from './isServiceDiscount.lib.samson';

const isTaxed = (item) =>
  !isDiscountService(item) && Number(item?.tax_rate || 0) > 0;

export default isTaxed;
